// Global CSS (kept)
import "./src/styles/global.css";

// HubSpot consent → Google Consent Mode bridge
export const onClientEntry = () => {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];
  // Define gtag if not present
  if (typeof window.gtag !== "function") {
    window.gtag = function(){ window.dataLayer.push(arguments); };
  }

  // HubSpot CMP listener
  window._hsp = window._hsp || [];
  window._hsp.push([
    "addPrivacyConsentListener",
    function (consent) {
      const hasAnalytics =
        !!consent && (consent.allowed || consent.categories?.analytics);
      const hasAds =
        !!consent && (consent.allowed || consent.categories?.advertisement);

      window.gtag("consent", "update", {
        ad_storage: hasAds ? "granted" : "denied",
        analytics_storage: hasAnalytics ? "granted" : "denied",
        ad_user_data: hasAds ? "granted" : "denied",
        ad_personalization: hasAds ? "granted" : "denied",
        // security_storage remains granted
      });
    },
  ]);
};

// SPA route change event for GTM (use as Custom Event trigger in GTM)
export const onRouteUpdate = ({ location }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "gatsby-route-change",
    page_path: location.pathname + location.search + location.hash,
  });
};
